import styled from 'styled-components';
import { aiManagementMenuItems, aiManagementMenuSurface } from 'styles/ai_management_menu';

export const Menu = styled.div`
  && {
    ${aiManagementMenuSurface}
  }

  ${aiManagementMenuItems}
`;
